import { differenceInMinutes, format } from "date-fns";
import { useFormatReservationDate as formatReservationDate } from "../../lib/datePickerHelper";
import { toZonedTime } from "date-fns-tz";

export const formatTitleDate = (date: string, timeZone: string) => {
  const _date = toZonedTime(new Date(date), timeZone);
  const _now = toZonedTime(new Date(), timeZone);

  if (differenceInMinutes(_date, _now) <= 0) {
    return "Now";
  }

  return `${formatReservationDate(_date)}, ${format(_date, "HH:mm")}`;
};
